import { Trans } from '@lingui/react/macro';
import { useState } from 'react';

import { useOrganizationList } from '@/api/organization';
import ExitIcon from '@/assets/svg/bx-exit.svg?react';
import UserIcon from '@/assets/svg/bx-user.svg?react';
import { Button, LinkButton } from '@/components/buttons';
import { GlobalLoader } from '@/components/GlobalLoader';
import { useLogOut } from '@/hooks/useLogOut';
import { ROUTES } from '@/router';

import InstanceSwitcherMenu from './InstanceSwitcherMenu';

type Props = {
  onInstanceChange: (instanceId: string) => void;
  onClose: () => void;
};

const InstanceSwitcherContent = ({ onInstanceChange, onClose }: Props) => {
  const { logOut } = useLogOut();
  const [isLoggingOut, setLoggingOut] = useState(false);

  const { organizations, error, isLoading } = useOrganizationList({});

  const handleLogOut = async () => {
    setLoggingOut(true);
    await logOut();
    setLoggingOut(false);
    onClose();
  };

  if (isLoggingOut) {
    return <GlobalLoader isLoggingOut />;
  }

  return (
    <div className="flex w-80 flex-col gap-2 p-1.5">
      <InstanceSwitcherMenu
        organizations={organizations}
        isLoading={isLoading}
        error={error}
        onSelectInstanceChange={onInstanceChange}
        onClose={onClose}
      />
      <div className="-m-1.5 flex justify-between bg-gray-100 p-1.5">
        <LinkButton variant="ghost" to={ROUTES.profile.path} onClick={() => onClose()}>
          <UserIcon />
          <Trans>Profile</Trans>
        </LinkButton>
        <Button variant="ghost" danger onClick={handleLogOut}>
          <ExitIcon />
          <Trans>Log Out</Trans>
        </Button>
      </div>
    </div>
  );
};

export default InstanceSwitcherContent;
